import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { BookingsRequestSendEmailComponent } from './bookings.request.send-email.component';
import { BookingsRequestSendSmsComponent }   from './bookings.request.send-sms.component';
import { SharedModule }                      from '../shared/shared.module';

@NgModule({
  declarations: [
    BookingsRequestSendEmailComponent,
    BookingsRequestSendSmsComponent
  ],
  entryComponents: [
    BookingsRequestSendEmailComponent,
    BookingsRequestSendSmsComponent
  ],
  imports: [
    SharedModule
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class BookingsModule {}
